/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import { useHistory } from 'react-router-dom';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikTextArea from 'src/components/formik/FormikTextArea';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import UserDropDown from 'src/business-components/UserDropDown';
import { WalletYupSchema } from 'src/containers/wallet-container/WalletPropTypes';
import { walletUpsertAction, walletResetAction } from './actions/WalletActions';
import RoutingUtil from 'src/utils/RoutingUtil';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { PAYMENT_MODE_TYPES_LIST, PAYMENT_TYPES_LIST } from '../product-container/ProductConstants';
import { isProduction } from 'src/config/index';
import { includeStamp } from 'src/utils/StampUtils';

const WalletFormRender = (props) => {
    const {
        values,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
    } = props;


    if (!isProduction()) {
        withFormikDevtools(props);
    }
    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Wallet Assignment</h5>
                <Form autoComplete="off">
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label>Agent/User Name</label>
                            <UserDropDown name="agentId" value={values.agentId} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Amount</label>
                            <FormikInput
                                name="amount"
                                type="text"
                                placeholder="Enter Amount to be paid"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Category</label>
                            <FormikInput
                                type="text"
                                className="form-control"
                                disabled
                                value="debit"
                                name="category"
                               
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Payment Type</label>
                            <FormikSelect
                                items={PAYMENT_TYPES_LIST}
                                name="payment_type"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Instrument No</label>
                            <FormikInput
                                name="instrument_number"
                                type="text"
                                placeholder="Transaction/Ref. No."
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Date</label>
                            <FormikDateTimePicker
                                name="payment_date"
                                className="form-control"
                                disableClock
                                format="dd-MM-yyyy"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Mode of Payment</label>
                            <FormikSelect
                                items={PAYMENT_MODE_TYPES_LIST}
                                name="mode"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Remarks</label>
                            <FormikTextArea
                                name="remarks"
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="text-center py-4 mt-3">
                        <FormikCreateSearchClear
                            isSubmitting={isSubmitting}
                            isUpdate={Boolean(values._id)}
                            onSearch={onSearch}
                            onClear={onClear}
                            resetForm={resetForm}
                            values={values}
                            submitScope="wallet.wallet_manager.manage.submit"
                            searchScope="wallet.wallet_manager.manage.search"
                        />
                    </div>
                </Form>
            </div>
        </div>
    );
};

WalletFormRender.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
    }),
};
let setSubmitting = () => { };

const WalletForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.WalletReducer, shallowEqual);

    usePrevious({ currentRecord, upsertReqStatus }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)
        ) {
            setSubmitting(false); 
        }
    });

    const onSubmit = useCallback((values, formikUtils) => {
        if (formikUtils) {
            ({ setSubmitting } = formikUtils);
        }
        formikUtils.setSubmitting(false);
        includeStamp(values);
        dispatch(walletUpsertAction(values));
    }, [dispatch]);

    const onSearch = useCallback(({ agentId,payment_type }) => {
        history.push(RoutingUtil.walletSearch({ agentId,payment_type }));
    }, [history]);

    const onClear = useCallback(() => {
        dispatch(walletResetAction());
    }, [dispatch]);

    return (
        <Formik
            onSubmit={onSubmit}
            onClear={onClear}
            enableReinitialize
            initialValues={currentRecord}
            validationSchema={WalletYupSchema}
            onSearch={onSearch}
        >
            {(formikProps) => (
                <WalletFormRender
                    onClear={onClear}
                    onSearch={onSearch}
                    {...formikProps}
                />
            )}
        </Formik>
    );
};

export default WalletForm;
